// Non-paginated variant — used for CSV export, where we want every row that
// matches the current filters in one shot rather than one page at a time.
// Omitting limit/offset puts the backend in its "return everything" mode.
export const getInboundCallSummaries = async (
  paginatedRequest,
  token,
  practiceId,
  {
    startDate = "",
    endDate = "",
    search = "",
    direction = "",
    duration = "",
    followUp = "",
  } = {},
) =>
  paginatedRequest(token, "/api/getInboundCallSummaries", {
    PracticeId: practiceId,
    startDate,
    endDate,
    search,
    direction,
    duration,
    followUp,
  });

// Paginated variant — used by SummaryTab to fetch one page at a time and
// surface X-Total-Count / X-Has-More / X-Next-Offset back to the caller.
export const getInboundCallSummariesPaginated = async (
  paginatedRequest,
  token,
  practiceId,
  {
    limit = 25,
    offset = 0,
    startDate = "",
    endDate = "",
    search = "",
    direction = "",
    duration = "",
    followUp = "",
  } = {},
) =>
  paginatedRequest(token, "/api/getInboundCallSummaries", {
    PracticeId: practiceId,
    limit,
    offset,
    startDate,
    endDate,
    search,
    direction,
    duration,
    followUp,
  });

export const markSummaryRead = async (
  usersPostRequest,
  token,
  transcriptId,
  practiceId,
  source = "inbound",
) =>
  usersPostRequest(
    token,
    `/api/summary/${transcriptId}/read?PracticeId=${practiceId}&source=${encodeURIComponent(source)}`,
    {},
  );
